<template>
  <div class="flex items-center">
    <p @click.stop.prevent class="text-inherit hover:text-primary">{{ timePlayed }}</p>
  </div>
</template>

<script>
export default {
  computed: {
    timePlayed () {
      const time = this.params.value
      if (time > 60) {
        return `${Math.round((time / 60))  } Minutes`
      } else {
        return `${time  } Seconds`
      }
    }
  }
}
</script>
